import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const { user, refresh } = useAuth();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('');
  // Guard against React 18 StrictMode (or any re-render) double-firing the
  // POST /auth/verify-email — the token is single-use server-side and the
  // second call would otherwise return "invalid or expired".
  const calledRef = useRef(false);

  useEffect(() => {
    const token = search.get('token');
    if (!token) { setStatus('error'); setMessage('Verification link is missing or malformed.'); return; }
    if (calledRef.current) return;
    calledRef.current = true;
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/verify-email`, { token });
        setStatus('success');
        setMessage(`Email verified — ${res.data.email}.`);
        try { await refresh(); } catch {}
        setTimeout(() => navigate('/dashboard'), 2200);
      } catch (e) {
        setStatus('error');
        setMessage(e?.response?.data?.error || 'Verification link is invalid or expired.');
      }
    })();
  }, [search, navigate, refresh]);

  return (
    <div data-testid="verify-email-page" style={{ minHeight: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F7FA', padding: 24 }}>
      <div style={{ background: '#fff', border: '1px solid #D9E2EE', borderRadius: 14, padding: 36, maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 8 }}>{status === 'success' ? '✅' : status === 'error' ? '⚠️' : '⏳'}</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#0F2742', margin: '0 0 10px' }}>
          {status === 'verifying' ? 'Verifying your email…' : status === 'success' ? 'You\'re verified' : 'Verification failed'}
        </h1>
        <p style={{ fontSize: 14, color: '#4a5e72', lineHeight: 1.5, margin: '0 0 22px' }}>
          {status === 'verifying' ? 'Hold tight — confirming your link.' : message}
        </p>
        {status === 'success' && (
          <Link to="/dashboard" style={{ display: 'inline-block', background: '#0F2742', color: '#fff', textDecoration: 'none', padding: '10px 18px', borderRadius: 8, fontWeight: 700, fontSize: 13 }}>
            Go to dashboard →
          </Link>
        )}
        {status === 'error' && user && (
          <Link to="/dashboard" style={{ display: 'inline-block', background: '#0F2742', color: '#fff', textDecoration: 'none', padding: '10px 18px', borderRadius: 8, fontWeight: 700, fontSize: 13 }}>
            Open dashboard
          </Link>
        )}
        {status === 'error' && !user && (
          <Link to="/login" style={{ display: 'inline-block', background: '#0F2742', color: '#fff', textDecoration: 'none', padding: '10px 18px', borderRadius: 8, fontWeight: 700, fontSize: 13 }}>
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
}
